/**
 * Sepet + drawer — influencer / kupon kodu (Shopify /discount/ + section yenileme)
 */
(function () {
  'use strict';

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function currentRedirectPath() {
    return window.location.pathname + (window.location.search || '');
  }

  function isPremiumCartPage() {
    return !!(window.__CURSE_CART_PAGE__ || document.getElementById('CursePremiumCart'));
  }

  async function fetchCartJson() {
    var res = await fetch(shopifyRoot() + 'cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  }

  async function refreshCartDrawerSections() {
    if (isPremiumCartPage()) {
      window.location.reload();
      return fetchCartJson();
    }

    var drawer = document.querySelector('cart-drawer');
    var sectionUrl = shopifyRoot() + 'cart?section_id=cart-drawer';

    var cart = await fetchCartJson();
    var sectionRes = await fetch(sectionUrl, { credentials: 'same-origin' });
    var sectionHtml = await sectionRes.text();

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({
        item_count: cart.item_count,
        sections: { 'cart-drawer': sectionHtml }
      });
    } else if (drawer && typeof drawer._swapDrawerHTML === 'function') {
      drawer._swapDrawerHTML(sectionHtml);
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'curse-cart-discount' } }));
    } catch (e) {}

    if (window.__curseCartPrefetch && typeof window.__curseCartPrefetch.refresh === 'function') {
      window.__curseCartPrefetch.refresh().catch(function () {});
    }

    return cart;
  }

  function discountApplied(cart, code) {
    if (!cart) return false;
    var codes = cart.discount_codes || [];
    var wanted = String(code || '').trim().toLowerCase();
    for (var i = 0; i < codes.length; i++) {
      var row = codes[i];
      if (!row || !row.code) continue;
      if (String(row.code).toLowerCase() === wanted && row.applicable) return true;
    }
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      return true;
    }
    if (typeof cart.total_discount === 'number' && cart.total_discount > 0) return true;
    return false;
  }

  function showDiscountError(form, message) {
    var err = form && form.querySelector('.curse-cart-discount__error');
    if (!err) return;
    if (message) {
      err.textContent = message;
      err.hidden = false;
    } else {
      err.textContent = '';
      err.hidden = true;
    }
  }

  async function applyDiscountCode(rawCode) {
    var code = String(rawCode || '').trim();
    if (!code) return { ok: false, message: 'Lütfen indirim kodu girin.' };

    var redirect = encodeURIComponent(currentRedirectPath());
    var url = shopifyRoot() + 'discount/' + encodeURIComponent(code) + '?redirect=' + redirect;

    await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    });

    var cart = await refreshCartDrawerSections();

    if (discountApplied(cart, code)) {
      return { ok: true };
    }

    var rows = cart.discount_codes || [];
    for (var j = 0; j < rows.length; j++) {
      var row = rows[j];
      if (row && String(row.code).toLowerCase() === code.toLowerCase() && row.applicable === false) {
        return { ok: false, message: 'İndirim kodu sepetinize uygulanamaz.' };
      }
    }

    return { ok: false, message: 'İndirim kodu sepetinize uygulanamaz.' };
  }

  async function clearDiscountCodes() {
    var redirect = encodeURIComponent(currentRedirectPath());
    await fetch(shopifyRoot() + 'discount/?redirect=' + redirect, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    });
    await refreshCartDrawerSections();
  }

  window.curseApplyCartDiscountCode = applyDiscountCode;
  window.curseClearCartDiscountCodes = clearDiscountCodes;

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('#cc-coupon-toggle');
    if (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : document.getElementById('cc-coupon-box');
      if (!panel) return;
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) panel.setAttribute('hidden', '');
      else panel.removeAttribute('hidden');
      return;
    }

    var removeBtn = e.target.closest('[data-curse-discount-remove]');
    if (removeBtn) {
      e.preventDefault();
      removeBtn.disabled = true;
      clearDiscountCodes().finally(function () {
        removeBtn.disabled = false;
      });
    }
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target.closest('#CartDrawer-DiscountForm, #cc-coupon-form');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();

    var input =
      form.querySelector('#CartDrawer-DiscountInput') ||
      form.querySelector('#cc-discount-input');
    var submit = form.querySelector('[type="submit"]');
    var code = input && input.value;

    showDiscountError(form, '');
    if (submit) submit.disabled = true;

    applyDiscountCode(code)
      .then(function (result) {
        // Noel teması (christmas.js) bu olayla kutlama / "olmadı" efektini oynatır
        try { document.dispatchEvent(new CustomEvent('curse:discount', { detail: { ok: !!result.ok, message: result.message || '' } })); } catch (evErr) {}
        if (result.ok) {
          if (input) input.value = '';
          showDiscountError(form, '');
        } else {
          showDiscountError(form, result.message || 'Kod uygulanamadı.');
        }
      })
      .catch(function () {
        showDiscountError(form, 'Bir hata oluştu. Tekrar deneyin.');
      })
      .finally(function () {
        if (submit) submit.disabled = false;
      });
    },
    true
  );
})();
